module.exports = __webpack_public_path__ + "img/10_4.2a207d2d.png";